"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgEyeHiddenOutline = function SvgEyeHiddenOutline(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M2 11.995c0-.93.654-1.452.654-1.452C5.855 7.51 8.99 6 11.995 5.995a9.22 9.22 0 0 1 1.628.143l-1.854 1.857c-1.02.088-1.886.482-2.595 1.183-.708.7-1.1 1.562-1.172 2.587l-1.756 1.758c-.303-1.264-.303-2.398 0-3.403C5.759 10.323 4.012 11.988 4 12c.264.3.929.891 1.995 1.774L4.63 15.132a23.856 23.856 0 0 1-1.978-1.689S2 12.925 2 11.995zm10.214 4c1.218-.132 2.13-.566 2.738-1.301.699-.846 1.048-1.672 1.048-2.479l1.696-1.672c.381.968.381 2.119 0 3.453 0 0 2.012-1.588 2.3-2.001a59.005 59.005 0 0 0-2-1.766l1.375-1.384c.662.5 1.327 1.066 1.994 1.698 0 0 .63.522.63 1.452 0 .93-.608 1.43-.608 1.43-3.21 3.046-6.387 4.564-9.392 4.57a9.338 9.338 0 0 1-1.623-.138l1.842-1.862zm8.01-13.641c.472-.472.944-.472 1.415 0 .472.471.472.942 0 1.414L3.77 21.636c-.472.472-.943.472-1.415 0-.471-.471-.471-.943 0-1.414l17.87-17.868z'
  }));
};

exports.default = SvgEyeHiddenOutline;